// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"4517bc18e52cf414","5285":"819128c4e2a51ee0"}[chunkId] + ".css";
};